export default "__VITE_ASSET__CwmOHQMi__"